import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonMenuToggle, IonRouterLinkWithHref } from '@ionic/angular/standalone';
import { Category } from '../../models/category';
import { ContextService } from '../../services/context.service';

@Component({
    selector: 'app-header-category-list',
    templateUrl: './header-category-list.component.html',
    styleUrls: ['./header-category-list.component.scss'],
    imports: [CommonModule, IonRouterLinkWithHref, IonMenuToggle, RouterLink],
})
export class HeaderCategoryListComponent implements OnInit {
    protected displayCategories: Category[] = [];
    /** When true, leaf categories emit selectedCategory instead of navigating via the menu. */
    @Input() emitLeaves = false;
    @Input() set categories(categories: Category[]) {
        // Remove categories with offer count = 0
        const platform = this.contextService.getPlatform();
        this.displayCategories = categories.filter((c) => c.hasOffersOnPlatform(platform) && c.isPlatform(platform));
    }
    @Output() selectedCategory = new EventEmitter<Category>();

    constructor(private readonly contextService: ContextService) {}

    ngOnInit() {}

    select(category: Category) {
        this.selectedCategory.emit(category);
    }
}
